import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ScrEnvironment } from 'src/environments/environment';
import { ScrAuthorizationService } from '../services';


/**
 * We send emails with reasonable looking URLs but need to redirect
 * the user to the actual location with our wacky angular navbar-laden paths.
 * This redirector sends the user to the correct location.
 */


@Injectable({
  providedIn: 'root'
})
export class EmailRedirectorGuard implements CanActivate {

  constructor(private logger: NGXLogger, private router: Router, private environment: ScrEnvironment, private authService: ScrAuthorizationService) {
  }


  canActivate(route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {

    this.logger.trace('email redirector ' + route.url.join(', '));

    if (this.environment.servicedesk) {
      if (route.url.length > 2 && route.url[0].path === 'internalactivity') {
        this.logger.trace('process internal activity link ' + route.url);
        if (route.url[1].path === 'audit') {
          return this.router.parseUrl(`dashboard/(navbar-tab:operations/(operations-tab:audits;aid=${route.url[2].path}))`);
        }
        else if (route.url[1].path === 'resmon') {
          return this.router.parseUrl(`dashboard/(navbar-tab:operations/(operations-tab:resourcemonitor;ts=${route.url[2].path}))`);
        }
        else if (route.url[1].path === 'etl') {
          return this.router.parseUrl(`dashboard/(navbar-tab:operations/(operations-tab:etl;aid=${route.url[2].path}))`);
        }
        return this.router.createUrlTree(['dashboard', { outlets: { 'navbar-tab': ['account-search'] } }]);
      }
      else if (route.url.length > 1 && route.url[0].path === 'account') {
        return this.router.parseUrl(`dashboard/(navbar-tab:account-search;aid=${route.url[1].path})`);
      }
    }


    if (route.url.length > 2) {
      if (route.url[0].path === 'email' || route.url[0].path === 'redir') {
        if (route.url[1].path === 'order') {
          return this.router.parseUrl(`dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-list;orderId=${route.url[2].path}))`);
        }
        else if (route.url[1].path === 'sc') {
          return this.router.parseUrl(`dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-list;scId=${route.url[2].path}))`);
        }
        else if (route.url[1].path === 'na') {
          this.logger.trace('route for needs action ' + route.url[2].path);
          return this.router.parseUrl(`dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-needs-action;scId=${route.url[2].path}))`);
        }
        else {
          this.logger.warn('email redirector guard cannot process ' + route.url);
        }
      }
      //else {
      //  this.logger.warn('email redirector guard cannot process ' + route.url);
      //}
    }
    else if (route.url.length > 1) {
      if (route.url[0].path === 'email') {
        if (route.url[1].path === 'payment-method') {
          return this.router.parseUrl('dashboard/(navbar-tab:my-account/(my-account-tab:payment-method))');
        }
        else if (route.url[1].path === 'transfers') {
          return this.router.parseUrl('dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-code-transfers))');
        }
        else if (route.url[1].path === 'suspicious-activity') {
          return this.router.parseUrl('dashboard/(navbar-tab:suspicious-activity/(suspicious-activity-tab:carrier-reported-activities))');
        }
        else {
          this.logger.warn('email redirector guard cannot process ' + route.url);
        }
      }
    }
    //else {
    //  this.logger.warn('email redirector guard cannot process ' + route.url);
    //}

    return this.authService.basePathRedirector();
//    return this.router.parseUrl(`dashboard/(navbar-tab:my-shortcodes/(my-shortcode-tab:shortcode-list))`);
  }
}


